module.exports = __webpack_public_path__ + "img/zhxs.c1e0e3e9.jpg";